import i18n from "i18next"

import en from "./lang/en.json"
import vi from "./lang/vi.json"

i18n.init({ interpolation: { escapeValue: false }, lng: "vi", resources: { en: { translation: en }, vi: { translation: vi } } })
export default i18n
